import UpdateEditor from "./UpdateEditor";

export default UpdateEditor;